import { useMemo } from 'react';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';
import CompetitorIcon from 'presentation/components/competitor-icon/index.js';
import { useCompetitorsIconsQuery } from 'presentation/components/competitor-icon/hooks/index.js';

const ParticipantIconsInline = props => {
    const {
        participants,
        sportId,
        separator,
        mojitoTools: { config },
    } = props;
    const first = participants?.[0];
    const second = participants?.[1];

    const competitors = useMemo(() => (first && second ? [first, second] : []), [first, second]);
    const { icons } = useCompetitorsIconsQuery({
        config: config.competitorIconOptions,
        competitors,
        sportId,
    });

    if (!first || !second) {
        return null;
    }

    const { showParticipantIcons: showIcons = true } = config.participantIcons || {};

    return (
        <FlexPane config={config.container} class="ta-ParticipantIconsInline">
            <Text class="ta-firstParticipantName" config={config.participantName}>
                {first.name}
            </Text>
            {showIcons && (
                <CompetitorIcon
                    config={config.participantIcon || {}}
                    title={first.name}
                    src={icons[0]}
                />
            )}
            <Text class="ta-separator" config={config.separator}>
                {separator}
            </Text>
            {showIcons && (
                <CompetitorIcon
                    config={config.participantIcon || {}}
                    title={second.name}
                    src={icons[1]}
                />
            )}
            <Text class="ta-secondParticipantName" config={config.participantName}>
                {second.name}
            </Text>
        </FlexPane>
    );
};

export default ParticipantIconsInline;
